import { render, staticRenderFns } from "./bindchannels.vue?vue&type=template&id=57d1bf12&"
import script from "./bindchannels.vue?vue&type=script&lang=ts&"
export * from "./bindchannels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bindchannels.vue"
export default component.exports